module.exports = __webpack_public_path__ + "static/media/bg_asia.e89e6eea.jpg";